import React from "react";
import './DownloadApp.scss'
import Header from "../../components/Header";
import Footer from "../../components/Footer";

let img_top = require("../../assets/mushroom/26.webp");
let img_playstore = require("../../assets/download-app/playstore.webp");
let img_appstore = require("../../assets/download-app/appstore.png");
let logo = require("../../assets/logo-sm-light.png");

function DownloadApp() {
    return (
        <div style={{backgroundColor: "#fafafa"}} className={"container-download-app"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Entra nel mondo di <span className={"orange"}>Geoticket</span>
                                </h1>
                                <h3>Scopri tutte le funzionalità dell'applicazione</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container features mt-4 mb-4"}>
                <div className="row">
                    <div className="col-md-6 card">
                        <img width={240} src={img_top}/>
                        <b>Acquista i ticket</b>
                        <small>Trova tutti i ticket che gestiamo</small>
                    </div>

                    <div className="col-md-6 card">
                        <img width={240} src={img_top}/>
                        <b>Mappa intelligente</b>
                        <small>Scopri la mappa unica per la ricerca dei funghi</small>
                    </div>
                    <div className="col-md-6 card">
                        <img width={240} src={img_top}/>
                        <b>Segna raccolta</b>
                        <small>Segna le tue zone di raccolta sulla mappa</small>
                    </div>
                    <div className="col-md-6 card">
                        <img width={240} src={img_top}/>
                        <b>Segna catture</b>
                        <small>Segna le catture pescate senza usare i fogli</small>
                    </div>
                </div>
            </div>
            <div className="container-row">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 d-flex justify-content-center align-items-center">
                            <img width={120} src={logo}/>

                        </div>
                        <div className="col-md-6 d-flex justify-content-center align-items-center flex-column">
                            <h3>Scarica l'App</h3>
                            <div className={"d-flex  flex-row"}>
                                <a href={"https://play.google.com/store/apps/details?id=com.geoticket"}>
                                    <img width={140} src={img_playstore}/>
                                </a>
                                <a href={"https://apps.apple.com/us/app/geoticket/id1475238989"}>
                                    <img width={140} src={img_appstore}/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default DownloadApp;